import React from "react";
import { DropdownButton, Button } from "../Button";
import icons from "../../constants/icons";
import { Input } from "../Input";
import "./styles.css";
import { CardHeader } from "../Header";
import moment from "moment";
import { connect } from "react-redux";
import language from "../../language";
import { onResetFilters } from "../../actions/Filters";
import dateFiltersOptions from "../../constants/dateFiltersOptions";

class DateFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCustomDate: true,
      show: false,
      startDate: moment()
        .startOf("D")
        .subtract(1, "month")
        .format("YYYY-MM-DD"),
      endDate: moment().endOf("D").format("YYYY-MM-DD"),
      isSubmitting: false,
      isResetting: false,
      dateFilterOption: {},
    };
  }

  componentDidMount() {
    const dateRange = {
      startDate:
        this.props.startDate ||
        moment().startOf("D").subtract(1, "month").format("YYYY-MM-DD"),
      endDate: this.props.endDate || moment().endOf("D").format("YYYY-MM-DD"),
    };
    this.setState({ ...dateRange });
  }

  onChangeDate(field, e) {
    this.setState({
      [field]: e?.target?.value,
    });
  }

  setDates = async () => {
    const { startDate, endDate } = this.state;

    this.setState({
      isSubmitting: true,
    });

    // if (this.props.filterName) {
    //   await this.props.dispatch(
    //     onAddFilter({
    //       [this.props.filterName]: {
    //         startDate,
    //         endDate,
    //       },
    //     })
    //   );
    // } else {
    //   await this.props.dispatch(
    //     onAddFilter({
    //       startDate,
    //       endDate,
    //     })
    //   );
    // }

    this.setState({
      isSubmitting: false,
    });

    this.props.handleApplyFilters &&
      this.props.handleApplyFilters(true, {
        startDate,
        endDate,
      });
  };

  resetDates() {
    this.setState({
      isResetting: true,
    });

    let dates = {
      startDate: moment()
        .startOf("D")
        .subtract(1, "month")
        .format("YYYY-MM-DD"),
      endDate: moment().endOf("D").format("YYYY-MM-DD HH:mm:ss"),
    };

    this.props.dispatch(onResetFilters(dates));

    this.setState({
      isResetting: false,
    });

    this.props.handleApplyFilters && this.props.handleApplyFilters(true, dates);
  }

  handleSelectCustomDateOption(dateFilterOption) {
    this.setState(
      {
        dateFilterOption,
        startDate: dateFilterOption.startDate,
        endDate: dateFilterOption.endDate,
      },
      () => {
        this.setDates();
      }
    );
  }

  render() {
    return (
      <DropdownButton
        text={
          language[this.props.defaultLanguage].date_range +
          ": " +
          " " +
          this.state?.startDate +
          " " +
          " " +
          this.state?.endDate
        }
        className="btn-transparent btn-bordered w-sm-100 btn-sm"
        leftIcon={icons.calendar}
        selectedData={this.state?.startDate + ":" + this.state?.endDate}
        disabled={this.props.disabled}
      >
        <CardHeader
          title={language[this.props.defaultLanguage].filter_by_date}
          borderBottom
          closeButton
        />
        <div className="dropdown-content">
          <div className="card-body">
            <div className="filters-date-list">
              {dateFiltersOptions(this.props.defaultLanguage).map((el, i) => {
                return (
                  <div
                    className={`filters-date-list-item`}
                    key={i}
                    onClick={() => this.handleSelectCustomDateOption(el)}
                  >
                    <div className="icon-container">
                      <span className={process.env.REACT_APP_ICONS_TYPE}>
                        {icons.check}
                      </span>
                    </div>
                    <span>{el.name}</span>
                  </div>
                );
              })}
            </div>
            {this.state.isCustomDate && (
              <>
                <Input
                  label="Start Date"
                  placeholder="DD-MM-YYYY"
                  value={this.state.startDate}
                  type="date"
                  onChange={(e) => this.onChangeDate("startDate", e)}
                />
                <Input
                  label="End Date"
                  placeholder="DD-MM-YYYY"
                  value={this.state.endDate}
                  type="date"
                  onChange={(e) => this.onChangeDate("endDate", e)}
                />
              </>
            )}
          </div>
        </div>
        <div className="modal-footer">
          <Button
            text="Reset"
            className="btn-default"
            onPress={this.resetDates.bind(this)}
            isSubmitting={this.state.isResetting}
          />
          <Button
            text="Apply"
            onPress={this.setDates.bind(this)}
            isSubmitting={this.state.isSubmitting}
          />
        </div>
      </DropdownButton>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(DateFilter);
